import React from "react";
import Profile from '../asset/profile.jpeg';
import rjs from '../asset/rjs.png';
import uiux from '../asset/uiux.png';
import njs from '../asset/njs.png';

const About = () => {
    return (
        <section id="about" className="py-20 bg-blue-200">
            <div className="container mx-auto text-center">
                <h2 className="text-4xl font-bold mb-8" style={{ fontFamily: 'Young, serif' }}>
                    About Me
                </h2>

                <div className="flex flex-col items-center mb-12">
                    <img src={`${Profile}`} alt="Profile Picture" className="w-32 h-32 rounded-full object-cover mb-4 shadow-lg"/>
                    <p className="text-lg text-gray-700 mb-2">KIDI Intern</p>
                    <p className="text-xl text-gray-800 font-semibold" style={{ fontFamily: 'Young, serif' }}>I'm an Software Engineer Intern in KIDI, Telkom Edocourse</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

                <div className="bg-lime-300 rounded-3xl p-6  shadow-lg shadow-gray-500/100 relative w-81 h-80">
                    <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black rounded-full">
                        <img src={rjs} alt="React Logo" className="rounded-full w-24 h-24"/>
                    </div>
                    <h1 className="text-center text-3xl font-bold pt-16" style={{ fontFamily: 'Young, serif' }}>React Js</h1>
                    <p className="text-center mt-6" style={{ fontFamily: 'Roboto, sans-serif' }}>
                    React.js is a JavaScript Library used to create interactive and dynamic user interface ( UI ). React.js is an open source JavaScript framework developed by Facebook.
                    </p>
                </div>

                <div className="bg-lime-300 rounded-3xl p-6  shadow-lg shadow-gray-500/100 relative w-81 h-80">
                    <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black rounded-full">
                        <img src={uiux} alt="UIUX Logo" className="rounded-full w-24 h-24"/>
                    </div>
                    <h1 className="text-center text-3xl font-bold pt-16" style={{ fontFamily: 'Young, serif' }}>UI/UX</h1>
                    <p className="text-center mt-6" style={{ fontFamily: 'Roboto, sans-serif' }}>
                    UI/UX is a term that refes to User Interface (UI) and User Experience (ux) which are design disciplines that focus on User Interaction with products or services.
                    </p>
                </div>

                <div className="bg-lime-300 rounded-3xl p-6  shadow-lg shadow-gray-500/100 relative w-81 h-80">
                    <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black rounded-full">
                        <img src={njs} alt="Node Logo" className="rounded-full w-24 h-24"/>
                    </div>
                    <h1 className="text-center text-3xl font-bold pt-16" style={{ fontFamily: 'Young, serif' }}>Node Js</h1>
                    <p className="text-center mt-6" style={{ fontFamily: 'Roboto, sans-serif' }}>
                    Node JS is a platform runs JavaScript on the server side for real-time application of fast, scable, and responsive application making it popular.
                    </p>
                </div>

                </div>
                
            </div>
        </section>
    )
}

export default About;